import React from 'react';
import chroma from 'chroma-js';
import Histogram from 'histogram';
import ConservedDomains from './conserved_domains/conserved_domains';
import CollapsePreferences from '../sequenceserver/public/js/collapse_preferences';

class HistogramContainer extends React.Component {
    constructor(props) {
        super(props);
        this.name = 'General Stats';
        this.collapsePreferences = new CollapsePreferences(this);
        let isCollapsed = this.collapsePreferences.preferenceStoredAsCollapsed();
        this.state = { collapsed: isCollapsed, ...props };
    }

    renderHistogram() {
        // The color palette utilized within Circojs.
        // https://loading.io/color/feature/RdYlBu-7/
        // scale colors : https://gka.github.io/chroma.js/#scale-colors
        var colors = chroma.scale('RdYlBu').colors(7)

        return (
            <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 pt-5'>
                <Histogram queries={this.state.queries} query="evalue" name="E-Value distribution" color={colors[0]} />
                <Histogram queries={this.state.queries} query="similarity" name="Sequence similarities distribution" color={colors[0]} />
                <Histogram queries={this.state.queries} query="hsps_per_hit" name="HSPs per hit" color={colors[0]} />
                <Histogram queries={this.state.queries} query="qcov" name="Query coverage per HSP" color={colors[0]} />
                <Histogram queries={this.state.queries} query="qcov_per_subject" name="Query coverage per subject" color={colors[0]} />
            </div>
        )
    }

    render() {
        return (
            <div className='histogram-container'>
                <div className="histogram-header">
                    <h4 className="caption" onClick={() => this.collapsePreferences.toggleCollapse()}>
                        {this.collapsePreferences.renderCollapseIcon()}
                        &nbsp; BLAST analysis statistics
                    </h4>
                </div>

                {!this.state.collapsed && this.renderHistogram()}
            </div>
        )
    }
}

export default class ReportPlugins {
    constructor(parent) {
        this.parent = parent;
        this.setStateFromConservedDomainsJSON = this.setStateFromConservedDomainsJSON.bind(this);
    }

    init(callback) {
        this.onResultsFetched = callback;
        this.fetchConservedDomains();
    }

    replacePluginResults(results, conservedDomainsResults) {
        const updatedResults = results.map(result => {
            if (result.type === ConservedDomains) {
                return this.queryResult(result.props.query, conservedDomainsResults);
            } else {
                return result;
            }
        });

        return updatedResults;
    }

    fetchConservedDomains() {
        const path = location.pathname + '/conserved-domains.json' + location.search;
        this.parent.pollPeriodically(path, this.setStateFromConservedDomainsJSON, this.parent.props.showErrorModal);
    }

    setStateFromConservedDomainsJSON(responseJSON) {
        this.onResultsFetched(responseJSON.BlastOutput2);
    }

    conservedDomainsForQuery(queryId, conservedDomainsResults) {
        const blastOutput = conservedDomainsResults || [];

        return blastOutput.find(result => {
            var queryTitle = result.report.results.search.query_title || ""
            return queryTitle.startsWith(queryId) || result.report.results.search.query_id == queryId;
        }) || {};
    }

    queryResult(query, conservedDomainsResults) {
        const conservedDomains = this.conservedDomainsForQuery(query.id, conservedDomainsResults);
        const isEmptyObject = Object.keys(conservedDomains).length === 0;

        const key = isEmptyObject ? 'Empty_CD_' + query.id : 'CD_' + query.id;
        return(
            <ConservedDomains key={key} query={query} conservedDomains={conservedDomains} program={this.parent.state.program}/>
        )
    }

    generateStats(queries) {
        if (queries === undefined) return null;

        var hit_num = 0;
        queries.some((query) => {
            hit_num += query.hits.length;
        });

        return hit_num > 1 ? ( <HistogramContainer program={this.parent.state.program} queries={queries} /> ) : ( <span></span> )
    }
}
